import { CheckboxMultipleBlankIcon } from './CheckboxMultipleBlankIcon';

/**
 * author: Austin Andrews
 * id 2B01AE9D-AFA4-4CDA-82BD-21076D27C006
 * name checkbox-multiple-blank
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-multiple-blank.svg
 * tags
 * - Form 
 */
export const CheckboxesBlankIcon = CheckboxMultipleBlankIcon;
export default CheckboxesBlankIcon